import { createReduxModule } from "hooks-for-redux";
import { StatusCodes } from "http-status-codes";
import { getSearchContent } from "../api/searchApi";
import { ISearchContentResponse } from "../api/searchApi.types";

const initialState: ISearchContentResponse = {
  heading: "",
  searchBarPlaceholder: "",
  clearButtonLabel: "",
  searchButtonLabel: "",
  pageNumbersText: "",
  pageButtonLabel: "",
  nextButtonLabel: "",
  filtersLabel: "",
  contentTypeFilterLabel: "",
  yearFilterLabel: "",
  contentSourceFilterLabel: "",
  topicsFilterLabel: "",
  articleResultLabel: "",
  playlistResultLabel: "",
  videoResultLabel: "",
  podcastResultLabel: "",
  audioResultLabel: "",
  guideResultLabel: "",
  eventResultLabel: "",
  marketingResultLabel: "",
  pressReleaseResultLabel: "",
  siteContentResultLabel: "",
  storeResultLabel: "",
  noResultsText: "",
  errorResultsText: "",
  clearAllLabel: "",
  searchPageUrl: "",
  thumbnailPlaceholder: "",
  restrictedContentText: "",
};

export const [useSearchContent, { setSearchContent }, searchStore] =
  createReduxModule("searchContent", initialState, {
    // Reducers
    setSearchContent: (
      searchContent: ISearchContentResponse,
      partialSearchContent: ISearchContentResponse
    ) => ({ ...searchContent, ...partialSearchContent }),
  });

export const updateSearchContent = async (language: string = "") => {
  const result = await getSearchContent(language);
  if (result?.status !== StatusCodes.OK) return result?.status;

  setSearchContent(result.data);

  return StatusCodes.OK;
};
